module.exports = __webpack_public_path__ + "img/icon-reddit.7b0c4b1d.svg";